export function pxToRem(number) {
    const numberValue = typeof number === 'string'
        ? Number(number.replace(/[^\d.]/g, '') || 0)
        : number;
    return numberValue / 16;
}
//# sourceMappingURL=pxToRem.js.map